var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.88673 0.417929L7.47658 6.35543C7.64747 6.53609 7.7329 6.76793 7.7329 6.99996C7.7329 7.23188 7.64744 7.46363 7.47658 7.64449L1.88673 13.582C1.53048 13.957 0.937122 13.9726 0.561341 13.6171C0.182904 13.2607 0.169544 12.6648 0.52472 12.2914L5.54035 6.9984L0.52472 1.70543C0.169544 1.33199 0.182826 0.740195 0.561341 0.381211C0.937122 0.0261324 1.53048 0.0417575 1.88673 0.417929Z",
    fill: "#8A0538"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowOutline);
export default __webpack_public_path__ + "static/media/RightArrowOutline.c882f763c8e695e7e82386281e9c8535.svg";
export { ForwardRef as ReactComponent };